import React, { memo, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate, I18n } from '@fiverr-private/i18n-react';
import { Textarea } from '@fiverr-private/fit';
import { useMessage } from '../../context/contexts/message';
import { selectFocusFlag, useValidationContext } from '../../context/contexts/validation';
import { MAX_LENGTH } from '../../constants';
import { isMobileView } from '../../utils/general';
import MessageControls from '../MessageControls';
import { Attachments } from '../Attachments';
import { selectSellerName, selectSendMessagePlaceholder, useStaticContext } from '../../context/contexts/static';
import QuickQuestions from '../QuickQuestions';
import questionClasses from '../QuickQuestions/Question/style.module.scss';
import TextareaFooter from './TextareaFooter';

import classes from './style.module.scss';

const TextareaWrapper = ({ drawerView, className: classNameCustom, controlClass, attachmentsClass }) => {
    const { isRequestToOrderModal } = useStaticContext();
    const context = useStaticContext();
    const validationContext = useValidationContext();
    const sellerName = selectSellerName(context);
    const sendMessagePlaceholder = selectSendMessagePlaceholder(context);

    const { isFocused, focus, clearFocus, focusRef } = selectFocusFlag(validationContext);

    useEffect(() => {
        setTimeout(() => focusRef?.current?.focus?.(), 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { message, onChange } = useMessage();

    const className = classNames(
        classes.textareaWrapper,
        {
            [classNameCustom]: drawerView,
            [classes.focus]: isFocused,
            [classes.withinRequestToOrder]: isRequestToOrderModal
        });

    const resetBottomSpace = drawerView ? 'p-b-0 m-b-0': '';
    const isMobile =  isMobileView();
    const quickQuestionsClassName = classNames({ 'p-r-16 p-l-16': isMobile, 'p-b-0 m-b-0': resetBottomSpace, 'p-l-24 p-r-24': !isMobile, [questionClasses.drawer]: drawerView });

    const showQuickQuestions = !isRequestToOrderModal;

    const params = { sellerName };
    const placeholderKey = drawerView ? 'send_message.textarea.contextual_placeholder_drawer' : 'send_message.textarea.contextual_placeholder';
    const placeholder = sendMessagePlaceholder || translate(placeholderKey, { params });
    const containerClassName = classNames({ [controlClass]: drawerView });
    const attachmentsClassName = classNames({ [attachmentsClass]: drawerView });
    return (
        <>
            {drawerView && (
                <div className="tbody-5 text-semi-bold m-b-12 co-grey-1100 m-r-32 m-l-32 p-t-12">
                    <I18n k="send_message.textarea.title"/>
                </div>
            )}
            <div className={className} data-testid="message-wrapper">
                <div className={classes.row}>
                    <Textarea data-testid="message-box"
                        ref={focusRef}
                        placeholder={placeholder}
                        className={classes.textarea}
                        maxLength={MAX_LENGTH}
                        onFocus={focus}
                        onBlur={clearFocus}
                        onChange={onChange}
                        value={message}/>
                    {showQuickQuestions && (
                        <QuickQuestions hideOnLongText={drawerView} containerClassName={quickQuestionsClassName}/>
                    )}
                    {drawerView && <MessageControls className={containerClassName}/>}
                    {!drawerView && <TextareaFooter/>}
                </div>
                {!drawerView && <Attachments/>}
            </div>
            {drawerView && <TextareaFooter drawerView={drawerView}/>}
            {drawerView && <Attachments className={attachmentsClassName}/>}
        </>
    );
};

TextareaWrapper.propTypes = {
    drawerView: PropTypes.bool,
    attachmentsClass: PropTypes.string,
    className: PropTypes.string,
    controlClass: PropTypes.string
};

export default memo(TextareaWrapper);
